import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@design-system/Carousel';
import {
  BoosterBlockerCard
} from '@screens/HomePage/MoodMemoryAndFocusPage/BoosterBlockerCard';
import { Badge } from '@viome/viome-base/src/usecase/Home/Home.model';

interface BadgeSectionProps {
  badgeItems: Badge[];
  influencer: 'booster' | 'blocker';
  'data-testid'?: string;
}

export const BadgeSection = ({ badgeItems, influencer, 'data-testid': testId }: BadgeSectionProps) => {
  return (
    <div className="space-y-4" data-testid={testId}>
      <Carousel
        className="relative"
        opts={{
          align: 'start',
          dragFree: true,
        }}
        data-testid="badgeSection-carousel"
      >
        <CarouselContent className="-ml-4" data-testid="badgeSection-carouselContent">
          {badgeItems?.map((badge: Badge, index) => (
            <CarouselItem
              key={badge.badge_name}
              className="flex basis-44 !gap-2"
              data-testid={`badgeSection-carouselItem-${index}`}
            >
              <BoosterBlockerCard
                badgeItem={badge}
                mood={badge.badge_name}
                influencer={influencer}
                data-testid={`badgeSection-boosterBlockerCard-${index}`}
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious variant="ghost" data-testid="badgeSection-carouselPrev" />
        <CarouselNext variant="ghost" data-testid="badgeSection-carouselNext" />
      </Carousel>
    </div>
  );
};
